import { Component } from 'react';
import Link from 'next/link';
import Layout2x1ImageLeft from 'components/Layout2x1ImageLeft';
import Layout2x1ImageRight from 'components/Layout2x1ImageRight';
import Picture from 'components/Picture';
import DoubleHeader from 'components/DoubleHeader';
import NextSteps from 'components/NextSteps';
import SalesCalloutHTO from 'components/SalesCalloutHTO';
import SalesCalloutSwatches from 'components/SalesCalloutSwatches';
import IconCheck from 'components/IconCheck';
import { withPageStaticProps } from 'utils/header';

class FitProcess extends Component {
  render() {
    return (
      <>
        <Layout2x1ImageRight
          hero
          className="m-section-hero"
          image={
            <Picture
              hero
              className="aspect-ratio-16by9"
              focalPointY={0}
              url="https://gentux.imgix.net/1632504466_menguinhiwfitprocessimgoffitprocess116by9.jpg"
              alt="Computer screen where the user is entering their fit information so we can calculate their suit size."
            />
          }
        >
          <DoubleHeader hero smallTitle={<h2>How This Works:</h2>} largeTitle={<h1>Online Fitting</h1>} />
          <ul className="mb-32 ml-32 list-none">
            <li className="flex space-x-8 ">
              <IconCheck className="h-24" />
              <div className="col-">Final fit guaranteed</div>
            </li>
            <li className="flex space-x-8 ">
              <IconCheck className="h-24" />
              <div className="col-">Size suggestions from algorithm</div>
            </li>
            <li className="flex space-x-8 ">
              <IconCheck className="h-24" />
              <div className="col-">Every order hand-checked</div>
            </li>
          </ul>
        </Layout2x1ImageRight>
        <Layout2x1ImageLeft
          className="p-section bg-white xs:bg-transparent xs:bg-panel-8/12-to-left"
          image={
            <Picture
              url="https://gentux.imgix.net/menguin_guy_on_laptop_how_it_works.jpg"
              alt="Man on a computer picking a suit for his event on the Menguin website."
            />
          }
        >
          <h2 className="text-h2 ml-0 xs:-ml-32 sm:-ml-64">We'll walk you through how to find your&nbsp;sizes</h2>
          <p>
            Not sure how this whole online fitting thing works? Don’t worry, we’ve done this thousands of times. We’ll walk you through how
            to find your sizes from clothes you already have in your closet. Don’t know one of the measurements? If all else fails, you can
            go to a tailor for your&nbsp;sizes.
          </p>
        </Layout2x1ImageLeft>
        <Layout2x1ImageLeft
          className="m-section mb-0"
          image={
            <h2>
              <DoubleHeader hero smallTitle={"Don't worry"} largeTitle={'We have a Fit Guarantee'} />
            </h2>
          }
        >
          <p>
            You will receive your items about 14 days in advance of your event. If any items do not fit, then we’ll send you free
            replacements right&nbsp;away.
          </p>
          <Link
            href="/collection/[category]"
            as="/collection/tuxedos-and-suits"
            className="btn-info tracker-cta-fit_process-guarantee-20190606-153702 btn"
          >
            Get Started
          </Link>
        </Layout2x1ImageLeft>
        <NextSteps
          ctaPageName="fit_process"
          salesCallout1={<SalesCalloutHTO ctaPageName="fit_process" />}
          salesCallout2={<SalesCalloutSwatches ctaPageName="fit_process" />}
        />
      </>
    );
  }
}

export const getStaticProps = withPageStaticProps();

export default FitProcess;
